import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal, Eyebrow } from "./Reveal";
import { MaskedLine, FadeUp, Grow } from "./motion";

export const FinalCta = () => (
    <section className="bg-[#0D131F] hero-grid text-white" data-testid="final-cta-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-28">
            <Reveal>
                <Eyebrow dark>Talk to ALBL</Eyebrow>
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08] mt-5 max-w-3xl">
                    YOUR BUSINESS DESERVES MORE THAN ANOTHER MARKETING AGENCY.
                </h2>
                <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                    Tell us where your business is today. We&apos;ll help you identify where your
                    marketing is leaving growth on the table.
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        to="/contact"
                        data-testid="final-cta-talk-button"
                        className="btn-sharp bg-[#C5A059] text-[#0D131F] text-xs font-bold tracking-[0.15em] uppercase px-8 py-4"
                    >
                        Talk to ALBL
                    </Link>
                    <a
                        href={SITE.whatsappPrefill}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="final-cta-whatsapp-button"
                        className="btn-sharp flex items-center gap-2 border border-white/25 text-white text-xs font-bold tracking-[0.15em] uppercase px-8 py-4 hover:border-[#25D366] hover:text-[#25D366]"
                    >
                        <MessageCircle className="h-4 w-4" /> WhatsApp
                    </a>
                </div>
                <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-sm text-slate-400">
                    <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="final-cta-phone">
                        <Phone className="h-4 w-4 text-[#C5A059]" /> {SITE.phone}
                    </a>
                    <a href={SITE.emailHref} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="final-cta-email">
                        <Mail className="h-4 w-4 text-[#C5A059]" /> {SITE.email}
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export const PageHero = ({ eyebrow, title, sub }) => (
    <section className="bg-[#0D131F] hero-grid text-white pt-32 sm:pt-40 pb-16 sm:pb-24 relative overflow-hidden">
        <div className="hero-noise" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <FadeUp y={14}>
                <Eyebrow dark>{eyebrow}</Eyebrow>
            </FadeUp>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] mt-5 max-w-4xl">
                <MaskedLine delay={0.12}>{title}</MaskedLine>
            </h1>
            {sub && (
                <FadeUp delay={0.4}>
                    <p className="mt-6 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">
                        {sub}
                    </p>
                    <Grow delay={0.55} className="mt-8">
                        <div className="gold-rule" />
                    </Grow>
                </FadeUp>
            )}
        </div>
    </section>
);
